import React, { } from "react";
import { ActivityType, ActivityListing } from "../../amorg-common";
import * as dateMath from 'date-arithmetic';
import { getActivities } from "../../api/activityClientApi";
import { GraphPeriod } from "../../utils/graphUtils";
import { ActivityGraph } from "./ActivityGraph/ActivityGraph";

type ActivityTimeLineProps = {
    yearMonthStart: Date;
};
export function ActivityTimeLine (props: ActivityTimeLineProps): JSX.Element 
{
    const [state, setState] = React.useState<{ loading: boolean, activities: ActivityListing[], graphPeriod: GraphPeriod; }>(
        {
            loading: true,
            activities: [],
            graphPeriod:
            {
                startMonthYear: new Date(
                    props.yearMonthStart.getFullYear(),
                    props.yearMonthStart.getMonth(),
                    1,
                    0,
                    0,
                    0
                ),
                months: 12
            }
        });

    async function getPeriodActivities (period: GraphPeriod)
    {
        const start = period.startMonthYear;
        const end = dateMath.add(dateMath.add(start, period.months, 'month'), -1, 'milliseconds');
        return await getActivities(start, end, []);
    }

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            setState({
                ...state,
                loading: false,
                activities: await getPeriodActivities(state.graphPeriod)
            });
        };
        getData();
    }, []);

    async function handleClickNavigate (yearMonthStart: Date)
    {
        setState({ ...state, loading: true });

        const newPeriod: GraphPeriod = {
            startMonthYear: yearMonthStart,
            months: 12
        };
        const activities = await getPeriodActivities(newPeriod);
        setState({ loading: false, activities, graphPeriod: newPeriod });
    }

    const typedActivities: { type: ActivityType, activities: ActivityListing[]; }[] = [];
    const selectedActivityTypes: ActivityType[] = [
        'AnnualWorkgroupStatus', 'SafetyInspection', 'WorkgroupMeeting', 'WorkplaceAssessment', 'CustomForm'
    ];
    selectedActivityTypes.map(t => typedActivities.push({ type: t, activities: [] }));

    for (const a of state.activities)
    {
        const group = typedActivities.find(ta => ta.type === a.activityType);
        if (group)
            group.activities.push(a);
    }

    return (
        <ActivityGraph
            rowHeightPx={32}
            activities={state.activities.map(a => ({ ...a }))}
            yearMonthStart={state.graphPeriod.startMonthYear}
            onNavigate={handleClickNavigate}
        />
    );
}